
export default [
    // 配货单列表
    {
        path: "distribution",
        name: "distribution",
        component: () => import(/* webpackChunkName: "distribution" */ "@/views/boss/distribution/index"),
    },
    {
        path: "distribution/update/:type",
        name: "distributionQuery",
        component: () => import(/* webpackChunkName: "distribution" */ "@/views/boss/distribution/update"),

    },
    // 包裹列表
    {
        path: "package",
        name: "package",
        component: () => import(/* webpackChunkName: "package" */ "@/views/boss/package/index"),
    },
    {
        path: "packageUpdate/:type",
        name: "packageUpdate",
        component: () => import(/* webpackChunkName: "package" */ "@/views/boss/package/update"),
    },
]